import React from "react";

const I360Simple = ({ style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="42.354"
      height="31.214"
      viewBox="0 0 42.354 31.214"
      style={style}
      stroke="currentColor"
    >
      <g id="Raggruppa_599" transform="translate(-1319.482 -276.235)">
        <g id="Raggruppa_546" transform="translate(1222 226.118)">
          <text
            id="_360_"
            transform="translate(100.553 70.716)"
            fontSize="18"
            fontWeight="400"
          >
            <tspan x="0" y="0">
              360°
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  );
};

export default I360Simple;
